import { Button, Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import MangueraIcono from "../images/manguera-autoservicio.png";

const FuelButtonRoot = styled(Button, { shouldForwardProp: p => p !== "bgcolor" && p !== "selected" })(({ bgcolor, selected, dimmed }) => ({
  height: 300,
  margin: "0 4px", // Cambia el margen para evitar overflow
  borderRadius: "24px 24px 0 0",
  backgroundColor: bgcolor,
  filter: dimmed ? "grayscale(40%) brightness(40%)" : "none",
  color: "#FFF",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "flex-end",
  position: "relative",
  "&:hover": { backgroundColor: bgcolor },
}));

const FuelButton = ({ label, color, selected, dimmed, onClick, price }) => (
  <FuelButtonRoot bgcolor={color} selected={selected} dimmed={dimmed} onClick={onClick}>
    <Box
      sx={{
        position: "absolute",
        top: "55%",
        left: "50%",
        transform: "translateX(-50%)",
        backgroundColor: "#FFF",
        color: "#000",
        fontSize: 12,
        padding: "1px 3px",
        borderRadius: "3px",
        boxShadow: "0 1px 2px rgba(0,0,0,0.25)",
        whiteSpace: "nowrap",
      }}
    >
      {price}
    </Box>

    {/* Texto vertical */}
    <Typography
      sx={{
        writingMode: "vertical-rl",
        transform: "rotate(180deg)",
        fontWeight: "bold",
        fontSize: 14,
        letterSpacing: 1,
        lineHeight: 1,
        textAlign: "center",
        mb: 10,
      }}
    >
      {label}
    </Typography>
    {/* Icono */}
    <Box sx={{ mb: 1 }}>
      <Box component="img" src={MangueraIcono} sx={{ width: 50, height: 60 }} />
    </Box>
  </FuelButtonRoot>
);

export default FuelButton;
